import {ChangeDetectionStrategy, Component, inject, input, output} from '@angular/core';
import {toObservable, toSignal} from '@angular/core/rxjs-interop';
import {catchError, map, of, switchMap} from 'rxjs';
import {bzIconCloseCircle, bzIconQuickFilters} from '@bringoz/ui/icons';
import {PanelService} from '../../services/panel.service';
import {ViewSettingsHttpService} from '../../services/view-settings-http.service';
import {
  BringozQuickFilterSelection,
  BringozQuickFiltersSelectPanelComponent,
  BringozQuickFiltersSelectPanelData
} from '../bringoz-quick-filters-select-panel/bringoz-quick-filters-select-panel.component';

require('./bringoz-quick-filter-select.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-quick-filter-select',
  templateUrl: './bringoz-quick-filter-select.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozQuickFilterSelectComponent {

  readonly selectedId = input<string>();
  readonly pageName = input<string>();
  readonly placeholder = input<string>();
  readonly hideDisplay = input<boolean>(false);
  readonly isDisabled = input<boolean>(false);

  readonly selectionChange = output<BringozQuickFilterSelection>();

  readonly icons = {quickFilters: bzIconQuickFilters, reset: bzIconCloseCircle};

  private readonly panelService = inject(PanelService);
  private readonly viewSettingsHttpService = inject(ViewSettingsHttpService);

  readonly selectedName = toSignal(toObservable(this.selectedId).pipe(
    switchMap((selectedId) => {
      if (!selectedId) {
        return of<string>(undefined);
      }
      return this.viewSettingsHttpService.getByIds([selectedId]).pipe(
        map((quickFilters) => quickFilters[0]?.name),
        catchError(() => of<string>(undefined))
      );
    })
  ));

  onOpenPanel(event: MouseEvent) {
    const data: BringozQuickFiltersSelectPanelData = {
      selectedId: this.selectedId(),
      pageName: this.pageName()
    };

    this.panelService.open(BringozQuickFiltersSelectPanelComponent, event, data, {
      position: {originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top', offsetY: 4}
    }).afterClose$.subscribe((selection: BringozQuickFilterSelection | null) => {
      // A null result is a click outside the panel - nothing was picked.
      if (selection) {
        this.selectionChange.emit(selection);
      }
    });
  }

  onReset(event: MouseEvent) {
    event.stopPropagation();
    this.selectionChange.emit({selectedId: undefined});
  }
}
